import type { DefaultConfigSchedule } from "Reducers/projectSettings";

export const maxBackupIntervals = {
  h: 12,
  d: 365,
  w: 52,
  M: 12,
  y: 1
};

export const backupIntervalRegulator = (
  newNumber: number,
  intervalLabel: string
) => {
  if (intervalLabel === "h") {
    const hoursOptions = [12, 8, 6, 4, 3, 2, 1];
    return hoursOptions.find(option => {
      if (newNumber === option) return option;
      if (newNumber > option) return option;
    });
  } else if (intervalLabel === "d") {
    return newNumber <= 365 ? newNumber : 365;
  } else if (intervalLabel === "w") {
    return newNumber <= 52 ? newNumber : 52;
  } else if (intervalLabel === "M") {
    return newNumber <= 12 ? newNumber : 12;
  } else if (intervalLabel === "y") {
    return 1;
  }
};

const intervalSeparator = (interval: string): [string, string] =>
  interval.replace(/(\d*)([a-zA-Z])/, "$1 $2").split(" ") as [string, string];

const convertIntervalToHours = (interval: string): number => {
  const [intervalCount, intervalLabel] = intervalSeparator(interval);
  const count = +intervalCount;

  const labelOptions = {
    h: () => count,
    d: () => count * 24,
    w: () => count * 168,
    M: () => count * 720, // One month is treated as 30 days
    y: () => count * 8760
  };

  return intervalLabel ? labelOptions[intervalLabel]() : 0;
};

export const sortBackSchedule = (schedule: DefaultConfigSchedule[]) => {
  schedule.sort((a, b) => {
    if (
      convertIntervalToHours(a.interval) > convertIntervalToHours(b.interval)
    ) {
      return 1;
    } else if (
      convertIntervalToHours(a.interval) < convertIntervalToHours(b.interval)
    ) {
      return -1;
    }
    return 0;
  });
};

export const removeDuplicateInterval = (
  schedule: DefaultConfigSchedule[]
): DefaultConfigSchedule[] => {
  const copiedSchedule = [...schedule];

  return copiedSchedule.filter(
    (schedule, i, arr) =>
      arr.findIndex(
        sch =>
          convertIntervalToHours(sch.interval) ===
          convertIntervalToHours(schedule.interval)
      ) === i
  );
};

export const findSchedulesThatDoNotHaveMinimalInterval = (
  schedule: DefaultConfigSchedule[]
): DefaultConfigSchedule[] => {
  let shortestInterval = Number.POSITIVE_INFINITY;

  for (const sch of schedule) {
    const [intervalCount, intervalLabel] = intervalSeparator(sch.interval);
    if (intervalCount && intervalLabel) {
      const scheduleNum = convertIntervalToHours(sch.interval);
      if (scheduleNum < shortestInterval) shortestInterval = scheduleNum;
    }
  }

  if (shortestInterval === Number.POSITIVE_INFINITY) return [];

  return schedule.filter(
    sch =>
      sch.interval &&
      convertIntervalToHours(sch.interval) % shortestInterval !== 0
  );
};

export const sanitizeInput = (value: string): number =>
  parseInt(value.replace(/[a-zA-z]/g, ""));
